import { render, staticRenderFns } from "./ButtonField.vue?vue&type=template&id=0a649808&"
import script from "./ButtonField.vue?vue&type=script&lang=js&"
export * from "./ButtonField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VBtn,VBtnToggle,VInput})
